import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { UserBooking } from "./store/types";
import { useUserBookings } from "./hooks/useUserBookings";
import { useUserBookingsStore } from "./store";
import BookingCard from "./components/BookingCard";
import { useTranslation } from "react-i18next";

export const UserBookingsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getUserBookings, deleteBookingTimeSlot } = useUserBookings();
  const userBookings = useUserBookingsStore((s) => s.userBookings);
  const isLoading = useUserBookingsStore((s) => s.isLoading);
  const errorMessage = useUserBookingsStore((s) => s.errorMessage);

  useEffect(() => {
    void getUserBookings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBook = (booking: UserBooking) => {
    // Navigate to book slot page with the booking ID
    navigate(`/book-slot/${booking.id}`);
  };

  const handleDeleteBooking = async (
    userBookingId: number,
    bookingId: number
  ) => {
    await deleteBookingTimeSlot(userBookingId, bookingId);
  };

  if (isLoading) {
    return (
      <div className="min-h-[400px] flex items-center justify-center bg-sky-100 h-full">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-primary-600" />
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="m-4 text-red-600 bg-sky-100 h-full">{errorMessage}</div>
    );
  }

  return (
    <main className="h-full overflow-auto bg-sky-100">
      <div className="mx-auto max-w-7xl px-4 py-6">
        {!userBookings || userBookings.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            {t("bookings.none")}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {userBookings.map((booking) => (
              <BookingCard
                key={booking.id}
                booking={booking}
                onBook={handleBook}
                onDeleteBooking={handleDeleteBooking}
              />
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default UserBookingsPage;
